import { gql } from "@apollo/client";

export default gql`
  mutation addFavouriteArtifactMutation($artifactId: Int!) {
    addFavouriteArtifact(artifactId: $artifactId) {
      artifact {
        id
      }
      user {
        id
        favouriteArtifacts {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
`;
